import XRegExp from 'xregexp';

export function isPunctuation(char: string): boolean {
  return XRegExp.match(char, XRegExp('\\p{P}')) !== null;
}
